<template>
	<BaseCmsPage v-slot="{page}">
		<AuthMainLayout>
			<template #authContent>
				<h1>{{ page?.seo_h1 }}</h1>
				<div class="auth-edit-inner">
					<BaseAuthEditForm class="form-animated-label edit-form-animated-label" v-slot="{fields, loading, status}">
						<template v-if="status?.data?.errors?.length">
							<div class="global-error" v-for="error in status.data.errors" :key="error">{{ error.field }}: {{ error.error }}</div>
						</template>
						<div v-if="status?.success" class="global-success"><BaseCmsLabel :code="status.data.label_name" /></div>

						<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel, isTouched, value}">
							<BaseCmsLabel v-if="item.name == 'first_name'" class="auth-personal-information" code="personal_information" tag="h2" />
							<BaseCmsLabel v-if="item.name == 'company_name'" class="auth-company-information" code="company_information" tag="h2" />
							<BaseCmsLabel v-if="item.name == 'newsletter'" class="auth-newsletter-information" code="newsletter_information" tag="h2" />
							<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}, {'success': !errorMessage && isTouched && value}]">
								<BaseFormInput :id="item.name" />
								<BaseCmsLabel tag="label" :for="item.name" :code="item.name" />
								<span class="error" v-show="errorMessage" v-html="errorMessage" />
							</p>
						</BaseFormField>
						<button type="submit" :class="{'loading': loading}" :disabled="loading"><UiLoader size="small" v-if="loading" /><BaseCmsLabel code="save_information" /></button>
					</BaseAuthEditForm>
				</div>
			</template>
		</AuthMainLayout>
	</BaseCmsPage>
</template>

<style lang="less">
	.auth-edit-inner{
		padding: 36px 40px 40px; background: #fff; border-radius: 8px; box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.05);
		.edit-form-animated-label{
			display: block; column-count: 2; column-gap: 40px;
			.field{width: 100%; display: inline-block;}
			.field-newsletter{display: block;}
			.field-company_address{padding-bottom: 100px;}
			.global-error,.global-success{column-span: all;}
			.autocomplete-container{
				border-top: 0!important; padding: 0 5px 5px 0; top: 54px;
				ul{
					&::-webkit-scrollbar{-webkit-appearance: none; width: 5px; background: var(--gray); border-radius: var(--borderRadius);}
					&::-webkit-scrollbar-thumb{background-color: var(--blue); border-radius: 5px;box-shadow: 0 0 1px rgba(255,255,255,.5);}
				}
			}
		}
		@media (max-width: @m){
			background: none; box-shadow: none; border-radius: 0; padding: 0;
			.edit-form-animated-label{
				display: flex; flex-flow: column; column-count: inherit; column-gap: inherit;
				.field-company_address{padding-bottom: 10px;}	
			}	
		}
	}

	.auth-personal-information, .auth-company-information, .auth-newsletter-information{
		font-size: 20px; padding-bottom: 16px;
		@media (max-width: @m){font-size: 18px; padding-bottom: 12px;}	
	}
	.auth-company-information, .auth-newsletter-information{
		@media (max-width: @m){margin-top: 22px;}
	}
	@media (min-width: @m){
		.auth-newsletter-information{column-span: all; padding: 25px 0 0;}
	}
	.field-newsletter{
		column-span: all; margin: 16px 0 24px; padding: 21px 16px 20px!important; border: 1px solid var(--gray); border-radius: 3px;
		input[type=checkbox] + label:before{ top: -2px;}
		@media (max-width: @m){
			background: #fff; padding: 18px 16px 16px!important; margin: 0 0 20px;
			input[type=checkbox] + label{font-size: 12px;}	
		}
	}
</style>
